import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { ActivateAccountBody } from "@shared-kernel/application/ports/public/public-repository";

export const activateAccount = createApiThunk<void, ActivateAccountBody>(
  "users/activateAccount",
  async (body: ActivateAccountBody, { extra: { publicRepository } }) => {
    return publicRepository!.activateAccount(body);
  },
);

export const resetActivateAccount = createAction("users/resetActivateAccount");
